<template>
    <div>
        <div class="card" v-if="retornos && retornos.length">
            <div class="card-header d-flex justify-content-between alert-primary" class2="'alert-' + cor_cabecalho">
                <div>
                    <a class="card-link lead" data-toggle="collapse" href="#lista-retornos-paciente" v-if="!aberto">
                        Retornos Previstos
                    </a>
                    <span v-else class="lead">
                        Retornos Previstos
                    </span>

                    <span class="h5 ml-3 mb-0" v-if="cor_cabecalho != 'primary'"
                        :title="cor_cabecalho == 'danger' ? 'Retorno já vencido.' : 'Retorno perto de vencer.'">
                        <i class="fas fa-exclamation-triangle" :class="'text-' + cor_cabecalho"></i>
                    </span>
                </div>
                <div>
                    <span class="badge badge-primary">
                        {{ retornos.length }}
                    </span>
                </div>
            </div>
            
            <ul class="list-group" :class="aberto ? '' : 'collapse'" id="lista-retornos-paciente">
                <li class="list-group-item" v-for="(item, index) in retornos" :key="'R' + index"
                    :class="item.medico.id_pessoa != $store.state.user.id_pessoa ? 'list-group-item-secondary' : ''">
                    <div class="d-flex justify-content-between align-items-center">
                        <div :style="item.fl_ativo === false ? 'text-decoration: line-through;' : ''">
                            <div>
                                {{ item.procedimento.search }}
                            </div>
                            <div class="small">
                                <span class="font-weight-bold">
                                    {{ item.medico.search }} 
                                </span>
                                <span v-if="item.created_at">
                                    em {{ $util.getFormatDate(item.created_at.substr(0,10)) }}
                                </span>
                            </div>
                            <div>
                                Para: 
                                {{ $util.getFormatDate(item.dt_retorno) }}
                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                <span>{{ getHumanDuration (item.dt_retorno) }}</span>
                            </div>
                            <div v-if="item.st_observacoes" class="small text-muted">
                                {{ item.st_observacoes }}
                            </div>
                            <pre v-if="false">{{ item }}</pre>
                        </div>
                        <div>
                            <div>
                                <span v-if="item.fl_ativo">
                                    <button type="button" class="btn btn-outline-danger mr-3" @click="remover (item)" :disabled="$store.state.loading" v-if="item.id_retorno_atendimento">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                    <span v-if="false">
                                        <button type="button" class="btn btn-outline-success mr-3" @click="revisao (item)" :disabled="$store.state.loading">
                                            Marcar
                                        </button>
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import * as moment from 'moment';

export default {
    props: ['retornos', 'aberto'],

    computed: { 
        
        cor_cabecalho: function () { 

            if ( !this.retornos )
                return 'primary';

            if ( this.retornos.find(retorno => retorno.dt_retorno <= this.$util.hoje() ) )
                return 'danger';

            if ( this.retornos.find(retorno => retorno.dt_retorno <= this.$util.ultimo_dia_mes(this.$util.hoje()) ) )
                return 'warning';

            return 'primary';

        }

    },

    methods: { 
        remover (item) { 
            if ( !confirm('Confirma remover a programação de retorno?') )
                return;

            let ra = _.cloneDeep(item);
            ra.fl_ativo = false;
            ra = _.omit(ra, ['dt_retorno']);

            this.$util.atualizar(this, { 
                service: 'retorno_atendimentos',
                func: 'store',
                dados: ra,
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                    item.fl_ativo = false;
                }
            })

        },

        getFormatDate (date, format) {
            return moment(date, 'YYYY-MM-DD').format(format);
        },

        getHumanDuration (date) {
            let end = moment().startOf('day');
            let base = date.substr (0,10);

            if ( base == this.$util.hoje() )
                return 'hoje';
            else
                return moment.duration(moment(base, 'YYYY-MM-DD').diff(end)).humanize(true);
        },
    }
}
</script>